import React from 'react';
import { Link } from 'react-router-dom';
import type { Collection } from '../domain/collections';
import { BellOff, Lock, Star } from 'lucide-react';

interface CollectionCardProps {
  collection: Collection;
  /** Buttons for this card's group (leave, mute, …), shown under the link. */
  actions?: React.ReactNode;
}

export default function CollectionCard({ collection, actions }: CollectionCardProps) {
  const count = collection.listingCount;
  return (
    <div className="flex flex-col rounded-3xl bg-card transition-colors duration-300 hover:bg-secondary">
      <Link to={`/collections/${collection.id}`} className="group block flex-1 p-6">
        <div className="mb-3 flex flex-wrap items-center gap-2">
          {collection.isDefault && (
            <span className="inline-flex items-center gap-1 rounded-full bg-wood/15 px-3 py-1 text-xs font-semibold text-wood">
              <Star className="size-3" />
              Default
            </span>
          )}
          {collection.visibility === 'private' && (
            <span className="inline-flex items-center gap-1 rounded-full bg-muted px-3 py-1 text-xs font-semibold text-muted-foreground">
              <Lock className="size-3" />
              Private
            </span>
          )}
          {collection.isMuted && (
            <span className="inline-flex items-center gap-1 rounded-full bg-muted px-3 py-1 text-xs font-semibold text-muted-foreground">
              <BellOff className="size-3" />
              Muted
            </span>
          )}
        </div>
        <h3 className="text-xl font-semibold text-foreground">{collection.name}</h3>
        {collection.description && (
          <p className="mt-2 line-clamp-2 text-muted-foreground">{collection.description}</p>
        )}
        <p className="mt-4 text-sm font-medium text-muted-foreground">
          {count} {count === 1 ? 'listing' : 'listings'}
        </p>
      </Link>
      {actions && <div className="flex flex-wrap gap-2 px-6 pb-5">{actions}</div>}
    </div>
  );
}
